<section class="article-component-cont">
  <header>
    <h3 class="ent-color"><i class="fas fa-briefcase" aria-hidden="true"></i>{{trackerType()}} tracker</h3>
  </header>
  <div class="article-content">
    @if (noLOA()) {
      <ent-alert-message type="warning">{{ message.noLOA }}</ent-alert-message>
    }
    <div class="case-tracker">
      <!-- Case or REG60 tracker steps -->
      <ng-content></ng-content>
    </div>
  </div>
</section>
